export const NORMAL_SIZE = " w-15 h-15 mb-3 mt-5 ";
export const SMALL_SIZE = " w-11 h-11 ";
export const AVATAR_CLASS_NAME =
    "flex bg-New_Primary_Default border-New_Primary_Default border rounded-full text-center self-center justify-center items-center mx-auto";
export const MAIN_CONTAINER_CLASS = "relative w-full";
export const DASHBOARD_MENU_CONTAINER =
    "dropdown-menu hidden absolute z-[600] border rounded h-fit right-0 px-1 overflow-y-auto bg-white w-max drop-shadow-4xl";
